import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillSecurityShield = () => (
  <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4099 5.55625V3.36125C10.4099 2.95125 10.0999 2.48625 9.71491 2.33125L6.92991 1.19125C6.30491 0.936254 5.59991 0.936254 4.97491 1.19125L2.18991 2.33125C1.80991 2.48625 1.49991 2.95125 1.49991 3.36125V5.55625C1.49991 8.00125 3.27491 10.2913 5.69991 10.9613C5.86491 11.0063 6.04491 11.0063 6.20991 10.9613C8.63491 10.2913 10.4099 8.00125 10.4099 5.55625Z"
      fill="white"
    />
  </svg>
)

export default withDefaultStyles(FillSecurityShield)
